module.exports = __webpack_public_path__ + "img/airbase-stage_3.2.36478c89.jpg";